<template>
  <div>
    <div class="bottom">
      <div class="bw">
        <div class="ql-editor" v-html="bottomValue">

        </div>

      </div>
      <div class="b2">
        版权所有©中财首佳(北京)教育科技有限公司 京ICP备2026008095号
      </div>
    </div>
  </div>
</template>
<script>
// 这里可以导入其他文件（比如：组件，工具js，第三方插件js，json文件，图片文件等等）
// 例如：import 《组件名称》 from '《组件路径》';
export default {
  // import引入的组件需要注入到对象中才能使用
  components: {},
  props: ['isTeam'],

  data() {
    // 这里存放数据
    return {
      bottomValue:'',
    };
  },
  // 监听属性 类似于data概念
  computed: {},
  // 监控data中的数据变化
  watch: {},
  // 方法集合
  methods: {},
  // 生命周期 - 创建完成（可以访问当前this实例）
  created() {
    
    setTimeout(() => {
      this.bottomValue =this.$store.state.m_user.bottomValue
    }, 200);
  },
  // 生命周期 - 挂载完成（可以访问DOM元素）
  mounted() {},
  beforeCreate() {}, // 生命周期 - 创建之前
  beforeMount() {} // 生命周期 - 挂载之前
};
</script>
<style lang="less" scoped>
/* //@import url(); 引入公共css类 */
p  {
  text-align: center;
      margin-bottom: 6px;
      font-weight: 400;
      font-size: 14px;
      color: #ffffff;
}
.bottom {
  padding-top: 26px;
  font-family: Regular;
  width: 100%;
  height: 166px;
  background: #213e89;
  .bw {
    width: 1200px;
    margin: 0 auto;
    padding-bottom: 15px;
    border-bottom: 1px solid rgba(255, 255, 255, 0.5);
    .b1 {
      text-align: center;
      margin-bottom: 6px;
      font-weight: 400;
      font-size: 14px;
      color: #ffffff;
    }
  }
  .b2 {
    color: #fff;
    opacity: 0.5;
    text-align: center;
    line-height: 45px;
    font-weight: 400;
    font-size: 14px;
  }
}
</style>
